import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useLayoutEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import { updateFilters } from "store/filters/operations";
import { selectFilters } from "store/filters/selectors";
import { useTranslation } from "react-i18next";
import {
  FiltersButton,
  CapacityFilterButton,
  UsagesFilter,
  DatesFilterButton,
  OtherFiltersButton,
  PriceTypeFilterButton,
  SearchMap,
  StylesFilter,
} from "./components";
import { AdjustIcon, pinSvgIconPink, googleMapIcon } from "assets/icons";
import styles from "./styles.module.scss";
import FiltersFormMobile from "./FiltersFormMobile";
import PriceOrderFilterButton from "./components/PriceOrderFilterButton";

const Filters = ({
  moreFilterOptions,
  spaces,
  activeSpace,
  setActiveSpace,
}) => {
  const dispatch = useDispatch();
  const [t] = useTranslation("global");
  const filters = useSelector(selectFilters);
  const [isMapVisible, setIsMapVisible] = useState(false);
  let [filtersNavbarIsOpen, setFiltersNavbarIsOpen] = useState(false);

  const handleInstantBookingChange = () => {
    dispatch(updateFilters({ instant_booking: !filters.instant_booking }));
  };

  const handleWithLocksChange = () => {
    dispatch(updateFilters({ with_locks: !filters.with_locks }));
  };

  const handleTypeToggle = (type) => {
    const newType = filters.type === type ? "" : type;
    dispatch(updateFilters({ type: newType }));
  };

  const toggleMapVisibility = () => {
    setIsMapVisible((prev) => !prev);
  };

  const handleFavoriteChange = () => handleTypeToggle("favorite");
  const handleFocusOnChange = () => handleTypeToggle("zoom");
  const handleLastMinuteChange = () => handleTypeToggle("last_minute");

  const [headerHeight, setHeaderHeight] = useState("75px");
  const location = useLocation(); // tracks URL changes

  useLayoutEffect(() => {
    const updateHeaderHeight = () => {
      const header = document.getElementById("headerId");
      setHeaderHeight(header ? `${header.offsetHeight - 0.8}px` : "75px");
    };

    // Initial update on mount
    requestAnimationFrame(updateHeaderHeight);

    // Throttle updates on resize for smoother performance
    let resizeTimeout;
    const handleResize = () => {
      if (resizeTimeout) clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(
        () => requestAnimationFrame(updateHeaderHeight),
        100
      );
    };

    window.addEventListener("resize", handleResize);

    // Re-run on URL change
    updateHeaderHeight();

    return () => {
      window.removeEventListener("resize", handleResize);
      if (resizeTimeout) clearTimeout(resizeTimeout);
    };
  }, [location]); // Update whenever URL changes

  return (
    <div className={styles.filtersWrapper} style={{ top: `${headerHeight}` }}>
      <div className={styles.filtersWrapperDesktop}>
        <div className={`${styles.filters} pageContainer`}>
          <DatesFilterButton />
          <CapacityFilterButton />
          <PriceTypeFilterButton />
          <PriceOrderFilterButton />
          <UsagesFilter />
          <StylesFilter/>
          <FiltersButton
            label={t("space.instantReservation")}
            isActive={filters.instant_booking}
            onClick={handleInstantBookingChange}
          />
          {/* <FiltersButton
            label={t("space.withLocks")}
            isActive={filters.with_locks}
            onClick={handleWithLocksChange}
          /> */}
          <FiltersButton
            label={t("search.filters.favorites")}
            isActive={filters.type === "favorite"}
            onClick={handleFavoriteChange}
          />
          <FiltersButton
            label={t("search.filters.zoom")}
            isActive={filters.type === "zoom"}
            onClick={handleFocusOnChange}
          />
          <FiltersButton
            label={t("search.filters.lastMinute")}
            isActive={filters.type === "last_minute"}
            onClick={handleLastMinuteChange}
          />
          <OtherFiltersButton filterOptions={moreFilterOptions} />
          <div className={styles.mapToggleBtnContainer}>
            {!isMapVisible && (
              <div
                onClick={toggleMapVisibility}
                className={`${styles.mapToggleButton} ${
                  isMapVisible ? styles.active : styles.inactive
                }`}
                aria-label={isMapVisible ? "Close Map" : "Open Map"}
                style={{ backgroundImage: `url(${googleMapIcon})` }}
              >
                <img src={pinSvgIconPink} alt="map icon" />
              </div>
            )}
          </div>
        </div>
        <div className={`${styles.searchMapContainer} pageContainer`}>
          <SearchMap
            spaces={spaces}
            activeSpace={activeSpace}
            setActiveSpace={setActiveSpace}
            isMapVisible={isMapVisible}
            setIsMapVisible={setIsMapVisible}
            toggleMapVisibility={toggleMapVisibility}
          />
        </div>
      </div>
      <div className={`${styles.filtersWrapperMobile} pageContainer`}>
        <div className={styles.mobileButtonsContainer}>
          <div
            type="button"
            className={styles.adjustIconWrapper}
            style={{ backgroundImage: `url(${AdjustIcon})` }}
            onClick={() => setFiltersNavbarIsOpen(!filtersNavbarIsOpen)}
          ></div>
          <OtherFiltersButton filterOptions={moreFilterOptions} />
        </div>  

        <div
          className={`${styles.filtersNavbar} ${
            filtersNavbarIsOpen ? styles.active : styles.inactive
          }`}
          style={{
            top: `${headerHeight}`,
            height: `calc(100vh - ${headerHeight})`,
          }}
        >
          {filtersNavbarIsOpen && (
            <FiltersFormMobile
              closeForm={() => setFiltersNavbarIsOpen(false)}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Filters;